import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const sellLessonPackageGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const dealId = route.queryParamMap.get('dealId');

  if (!dealId) {
    return router.createUrlTree(['/']);
  }

  return true;
};
